import { render, staticRenderFns } from "./OpenText.vue?vue&type=template&id=e358c0d0&scoped=true&"
import script from "./OpenText.vue?vue&type=script&lang=js&"
export * from "./OpenText.vue?vue&type=script&lang=js&"
import style0 from "./OpenText.vue?vue&type=style&index=0&id=e358c0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e358c0d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e358c0d0')) {
      api.createRecord('e358c0d0', component.options)
    } else {
      api.reload('e358c0d0', component.options)
    }
    module.hot.accept("./OpenText.vue?vue&type=template&id=e358c0d0&scoped=true&", function () {
      api.rerender('e358c0d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/OpenText.vue"
export default component.exports